class YearServiceClass {
  constructor() {
    this._year = null;
    this._loading = false;
    this._promise = null;
  }

  async init() {
    if (this._year !== null) {
      return this._year;
    }

    if (this._loading && this._promise) {
      return this._promise;
    }

    this._loading = true;
    this._promise = this._fetchYear().then(year => {
      this._year = year;
      this._loading = false;
      return year;
    }).catch(() => {
      this._year = new Date().getFullYear();
      this._loading = false;
      return this._year;
    });

    return this._promise;
  }

  async _fetchYear() {
    try {
      const response = await fetch(process.env.REACT_APP_SERVER_URL + "general/get_year", {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
        mode: "cors"
      });
      
      if (response.ok) {
        const data = await response.json();
        return data;
      }
      return new Date().getFullYear();
    } catch (e) {
      return new Date().getFullYear();
    }
  }

  getYear() {
    return this._year || new Date().getFullYear();
  }

  isInitialized() {
    return this._year !== null;
  }
}

const YearService = new YearServiceClass();
export default YearService;

